import { useDropEventCard } from 'root/src/client/web/list/listItemComponents/dropEvent/hooks/useDropEventCard'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'
import defaultPublisherLogo from 'root/src/client/public/default-publisher-logo.png'
import classNames from 'classnames'
import { ProjectCardCircleImage } from 'root/src/client/web/list/listItemComponents/project/ProjectCardCircleImage'
import { withProjectCardStyle } from 'root/src/client/web/list/listItemComponents/style'

export const DropEventSeparator = withProjectCardStyle(({ classes }) => {
	const {
		dropEvent: { brand },
	} = useDropEventCard()

	const brandImage =		brand?.brandLogo?.small
		? addHttpsProtocol(brand.brandLogo.small)
		: defaultPublisherLogo.src

	return (
		<div className={classNames(
			'layout-row layout-align-center',
			classes.projectAssigne,
			classes.overlay,
		)}
		>
			<ProjectCardCircleImage
				src={brandImage}
				alt={brand?.brandName}
			/>
			<p className={classes.assigneesNames}>
				{brand?.brandName}
			</p>
		</div>
	)
})
